<script>
import { getSalesExecutives, deleteSalesExecutive } from '@/utils/sales-executive'
import SalesExecutiveModal from '@/components/modal/sales-executive-modal.vue'

export default {

    components: {
        SalesExecutiveModal
    },

    inject: ['setLoading'],

    data() {
        return {
            title: "Settings",
            text: "Administration",
            data: []
        }
    },

    mounted() {
        this.getData()
    },

    methods: {

        async getData() {
            this.setLoading(true)

            try {
                const res = await getSalesExecutives()
                this.data = res?.data?.data?.data || []
            } catch (error) {
                this.$swalToast(error.message, 'error')
            } finally {
                this.setLoading(false)
            }
        },

        confirmDelete(id) {
            this.$swal({
                title: "Confirm Delete",
                text: "You want to delete this sales executive!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes Delete",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.remove(id)
                }
            })
        },

        async remove(id) {
            this.setLoading(true)

            try {
                const res = await deleteSalesExecutive(id)
                this.$swalToast(res.data.message)
                this.getData()
            } catch (error) {
                this.$swalToast(error.message, 'error')
            } finally {
                this.setLoading(false)
            }
        }

    }

}
</script>

<template>

    <layout-header />
    <layout-sidebar />

    <div class="page-wrapper">
        <div class="content">

            <!-- Breadcrumb -->
            <div class="d-md-flex justify-content-between mb-3">
                <breadcrumb :title="title" :text="text" text1="Sales Executives" />
            </div>

            <settings-tab />

            <div class="row">

                <!-- LEFT -->
                <others-sidebar />

                <!-- RIGHT -->
                <div class="col-xl-9">

                    <div class="card">

                        <div class="card-header d-flex justify-content-between">
                            <h5>Sales Executives</h5>

                            <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#sales_executive_modal"
                                @click="$refs.salesExecutiveModal.open()">
                                <i class="ti ti-plus me-2"></i>
                                Add Sales Executive
                            </button>

                        </div>

                        <div class="card-body card-table-wrapper">

                            <div class="table-responsive">
                                <table class="card-table">

                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Mobile</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        <tr v-for="(row, index) in data" :key="row.id">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ row.user?.name }}</td>
                                            <td>{{ row.user?.email }}</td>
                                            <td>{{ row.user?.mobile }}</td>

                                            <td>
                                                <div class="dropdown">
                                                    <button class="btn btn-sm" data-bs-toggle="dropdown">
                                                        <i class="ti ti-dots"></i>
                                                    </button>

                                                    <ul class="dropdown-menu dropdown-menu-end">

                                                        <li>
                                                            <a class="dropdown-item" data-bs-toggle="modal"
                                                                data-bs-target="#sales_executive_modal"
                                                                @click="$refs.salesExecutiveModal.open(row)">
                                                                Edit
                                                            </a>
                                                        </li>

                                                        <li>
                                                            <a class="dropdown-item text-danger"
                                                                @click="confirmDelete(row.id)">
                                                                Delete
                                                            </a>
                                                        </li>

                                                    </ul>

                                                </div>
                                            </td>

                                        </tr>

                                        <tr v-if="!data.length">
                                            <td colspan="5" class="text-center p-3">No data</td>
                                        </tr>

                                    </tbody>

                                </table>
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

        <app-footer />

    </div>

    <sales-executive-modal ref="salesExecutiveModal" @updated="getData" />

</template>